import { render, staticRenderFns } from "./expressForwardingScan.vue?vue&type=template&id=f0d8e494&scoped=true"
import script from "./expressForwardingScan.vue?vue&type=script&lang=js"
export * from "./expressForwardingScan.vue?vue&type=script&lang=js"
import style0 from "./expressForwardingScan.vue?vue&type=style&index=0&id=f0d8e494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d8e494",
  null
  
)

export default component.exports